import { useMutation } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { OnboardingInvitationCredentials } from "@customTypes/accountManagement";

export const useInviteDoctor = () => {
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (inviteData: { identifier: string; roles: string[]; partner_id?: string }) => 
      api.post<OnboardingInvitationCredentials>(
        `onboarding/admin/invite`,
        inviteData
      ),
    onError: (res: any) => {
      console.error("[From Invite Doctor]", res);
      handleErrors(res, "mutation");
    },
  });
};
